import { requestHandler } from '../../api';

export const getAllCategories = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/tags/categories`,
    dispatch,
  });
  if (response) return response.data;
};

export const createCategory = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/tags/createCategory`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const deleteCategory = async (dispatch: any, id: number) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/tags/deleteCategory/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const updateCategory = async (dispatch: any, data: any, id: number) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/tags/updateCategory/${id}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const createTag = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/tags/createTag`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const deleteTag = async (dispatch: any, id: number) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/tags/deleteTag/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const updateTag = async (dispatch: any, data: any, id: number) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/tags/updateTag/${id}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessTags = async (
  dispatch: any,
  businessIdentifier: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/tags/businessTags/${businessIdentifier}`,
    dispatch,
  });
  if (response) return response.data;
};

export const addBusinessTag = async (
  dispatch: any,
  data: { businessIdentifier: string; tagId: number },
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/tags/businessTags/add`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const removeBusinessTag = async (
  dispatch: any,
  data: { businessIdentifier: string; tagId: number },
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/tags/businessTags/remove`,
    data,
    dispatch,
  });
  if (response) return response.data;
};
